import React, { useState } from "react";
import { Button, Grid, Link, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { Trans, useTranslation } from "react-i18next";

const Wrapper = styled(Grid)(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  zIndex: 1,
  background: theme.palette.background.grayPaper,
  padding: "30px 0",
  "& h3": {
    fontSize: 21,
    fontWeight: "bold",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "15px 0",
    "& h3": {
      fontSize: 16,
    },
  },
}));

const ButtonsWrapper = styled(Grid)(() => ({
  marginTop: 15,
  "& button:first-child": {
    marginRight: 15,
  },
}));

const CookiesBlock = (): JSX.Element => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation("translation");

  const acceptCookies = () => {
    document.cookie =
      "isCookieAccepted=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    setVisible(false);
  };

  const rejectCookies = () => {
    setVisible(false);
  };

  const isHiddenCookie = () => {
    return document.cookie.includes("isCookieAccepted");
  };

  return (
    <>
      {visible && !isHiddenCookie() && (
        <Wrapper container justifyContent="center">
          <Grid item xs={11} md={9}>
            <Typography variant="h3">
              {t("StartPage.WeUseCookies")}
            </Typography>
            <Typography variant="body1">
              <Trans
                components={{ b: <b /> }}
                i18nKey="StartPage.ClickToAgreeThatWeUseCookies"
              />
              &nbsp;
              <Link href="https://myhouse.dk/contact" target="_blank" underline="always">                
                {t("StartPage.Here")}
              </Link>
            </Typography>
            <ButtonsWrapper item>
              <Button
                variant="contained"
                color="secondary"
                onClick={acceptCookies}
              >
                {t("General.Buttons.Accept")}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={rejectCookies}
              >
                {t("General.Buttons.Reject")}
              </Button>
            </ButtonsWrapper>
          </Grid>
        </Wrapper>
      )}
    </>
  );
};

export default CookiesBlock;
